import React, { createContext, FunctionComponent, useContext } from "react";
import { Box, InputAdornment, Paper, TextField } from "@mui/material";
import { SearchIcon } from "assets";

export const SearchContext = createContext<{
  value: string;
  onChange: (v: string) => void;
  onContainerMouseDown: () => void;
}>({
  value: "",
  onChange: () => {},
  onContainerMouseDown: () => {},
});

export const SimplePaper: FunctionComponent<
  React.HTMLAttributes<HTMLElement>
> = (props) => <Paper {...props} />;

export const SearchablePaper: FunctionComponent<
  React.HTMLAttributes<HTMLElement>
> = (props) => {
  const { value, onChange, onContainerMouseDown } = useContext(SearchContext);
  const { children } = props;

  return (
    <Paper {...props}>
      <Box
        onMouseDown={onContainerMouseDown}
        sx={{
          p: 1,
          borderBottom: "1px solid",
          borderColor: "divider",
          position: "sticky",
          top: 0,
          zIndex: 1,
          backgroundColor: "white",
        }}
      >
        <TextField
          size="small"
          placeholder="Search..."
          fullWidth
          value={value}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key !== "Escape") e.stopPropagation();
          }}
          onClick={(e) => e.stopPropagation()}
        />
      </Box>
      {children}
    </Paper>
  );
};
